// extracted by mini-css-extract-plugin
export default {"backdrop":"LoadingProvider_backdrop__nEThq","loadingContainer":"LoadingProvider_loadingContainer__2tZdd"};